import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`

@font-face {
  font-family: 'Bueno-Regular';
    src: url('/fonts/Bueno-Regular.otf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Vogue';
    src: url('/fonts/Vogue.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}


@font-face {
  font-family: 'Bostony-Kintens';
    src: url('/fonts/Bostony-Kintens.otf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'PPEditorialSans-Medium';
    src: url('/fonts/PPEditorialSans-Medium.otf') format('truetype');
  font-weight: normal;
  font-style: normal;
}


:root {
--custom-highlight-color: #eaded2; 
//red 
--v1: #1E0309;
//neutral white
--v2: #F0E9DA;
//black/grey
--v3: #191817;
//burnt orange
--v4: #332D17;
}

::selection {
  background-color: var(--custom-highlight-color);
  color: #000814; 
 
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
    cursor: none;
}

body {
  height: 100vh;
 max-width: 100vw;
  margin: 0;
}


a {
  /* cursor: pointer; */
  text-decoration: none;
  color: inherit;
 }
`;

export default GlobalStyles;
